import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import AuditOutlined from '@ant-design/icons/lib/icons/AuditOutlined';
import FileDoneOutlined from '@ant-design/icons/lib/icons/FileDoneOutlined';
import TableOutlined from '@ant-design/icons/TableOutlined';
import { useOutletContext } from 'react-router-dom';
import { ViewSwitcher } from 'src/components/viewSwitcher/ViewSwitcher';
import { useAuth } from 'src/domain/auth/useAuth';
import { VIEW_MODE } from '../eventInterface';

export const EventViewSwitcher = () => {
    const { view, handleView } = useOutletContext<any>();
    const auth = useAuth()!;

    const viewOptions = [
        {
            title: 'Calendar View',
            value: VIEW_MODE.CALENDAR,
            tooltip: 'Calendar View',
            icon: <CalendarOutlined />,
            isVisible: true,
        },
        {
            title: 'Historical View',
            value: VIEW_MODE.HISTORY,
            tooltip: 'Historical View',
            icon: <TableOutlined />,
            isVisible: true,
        },
        {
            title: 'Tracking View',
            value: VIEW_MODE.TRACKING,
            tooltip: 'Tracking View',
            icon: <AuditOutlined />,
            isVisible: true,
        },
    ];

    if (auth.user?.isAdminRoleType()) {
        viewOptions.push({
            title: 'Company View',
            value: VIEW_MODE.COMPANY_PARTICIPATION,
            tooltip: 'Company Participation',
            icon: <FileDoneOutlined />,
            isVisible: true,
        });
    }

    return <ViewSwitcher key="event-view-switcher" viewOptions={viewOptions} view={view} handleViewMode={handleView} />;
};
